import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Block from './Block';
import BodyWrapper from './BodyWrapper';

// Retrocompatibilità: i vecchi blocchi salvavano gli elementi in `subblocks`
const getItems = (data) => data.items ?? data.subblocks ?? [];

const View = ({ data, isEditMode = false }) => {
  const intl = useIntl();

  return (
    <div className="block icons-lister">
      <BodyWrapper>
        {getItems(data).map((item, index) => (
          <Block
            key={item['@id'] ?? index}
            data={item}
            inEditMode={isEditMode}
            intl={intl}
          />
        ))}
      </BodyWrapper>
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.string,
  isEditMode: PropTypes.bool,
};

export default View;
